import {
  Alert,
  Box,
  Button,
  Container,
  FormControl,
  Link,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInUser, resetPassword } from "../firebase";
import AppHeader from "../components/AppHeader";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";

export default function Login() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [resetSent, setResetSent] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();

    if (!email || !password) {
      setError("Por favor ingrese su usuario y contraseña.");
      return;
    }

    setError("");

    try {
      await signInUser(email, password);
      navigate("/home");
    } catch (error) {
      console.error(error.message);
      setError(error.message);
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      setError("Por favor ingrese su dirección de correo electrónico.");
      return;
    }

    try {
      await resetPassword(email);
      setError("");
      setResetSent(true);
    } catch (error) {
      console.error(error.message);
      setError(error.message);
    }
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 2 }}>
      <AppHeader variant="brand" />
      <Typography variant="h5" component="h5" gutterBottom textAlign="center" sx={{ fontWeight: 300 }}>
        Inicio de sesión
      </Typography>
      {error && (
        <Alert severity="error" sx={{ my: 2 }}>
          {error}
        </Alert>
      )}
      <Box component="form" onSubmit={onSubmit}>
        <FormControl htmlFor="email" fullWidth>
          <TextField
            label="Email"
            variant="outlined"
            placeholder="your@email.com"
            type="email"
            autoComplete="email"
            autoFocus
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mt: 1 }}
            fullWidth
          />
        </FormControl>
        <FormControl htmlFor="password" fullWidth>
          <TextField
            label="Contraseña"
            variant="outlined"
            type={showPassword ? "text" : "password"}
            value={password}
            autoFocus
            required
            placeholder="••••••"
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
            sx={{ mt: 3 }}
            InputProps={{
              endAdornment: (
                <IconButton onClick={handleTogglePasswordVisibility} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
            }}
            fullWidth
          />
        </FormControl>
        <Button variant="contained" type="submit" sx={{ mt: 3 }} fullWidth>
          Iniciar sesión
        </Button>
        <Link
          href="#"
          onClick={handleForgotPassword}
          sx={{ mt: 1, display: "block", textAlign: "center" }}
        >
          Olvidé mi contraseña
        </Link>
        <Box sx={{ mt: 2, display: "block", textAlign: "center" }}>
          ¿Aún no tienes cuenta? <Link href="/register">Registrarse</Link>
        </Box>
      </Box>
      <Snackbar
        open={resetSent}
        autoHideDuration={5000}
        onClose={() => setResetSent(false)}
        message="Email de restablecimiento de contraseña enviado con éxito."
      />
    </Container>
  );
}
